export default __webpack_public_path__ + "static/media/bellUnread.ff95a022.svg";